import React from 'react';
import { Check, X } from 'lucide-react';
import { getPasswordChecks, PASSWORD_RULES } from '../lib/passwordPolicy';

// Live password-requirement checklist. Pass the current password value.
export const PasswordRequirements = ({ password = '', className = '' }) => {
  const checks = getPasswordChecks(password);
  return (
    <ul
      className={`grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1 text-xs ${className}`}
      data-testid="password-requirements"
    >
      {PASSWORD_RULES.map((r) => {
        const ok = checks[r.key];
        return (
          <li
            key={r.key}
            className={`flex items-center gap-1.5 transition-colors ${ok ? 'text-green-600 dark:text-green-400' : 'text-slate-400 dark:text-slate-500'}`}
            data-testid={`pw-rule-${r.key}-${ok ? 'ok' : 'no'}`}
          >
            {ok ? <Check className="w-3.5 h-3.5 flex-shrink-0" /> : <X className="w-3.5 h-3.5 flex-shrink-0" />}
            {r.label}
          </li>
        );
      })}
    </ul>
  );
};
